import { render, staticRenderFns } from "./ContratoData.vue?vue&type=template&id=4a71ac2c&"
import script from "./ContratoData.vue?vue&type=script&lang=js&"
export * from "./ContratoData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports